import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Clients from "./scenes/clients";
import Staff from "./scenes/staff";
import Services from "./scenes/services";
import Venues from "./scenes/venues";
import Vendors from "./scenes/vendors";
import MenuItems from "./scenes/menuitems";
import Events from "./scenes/events";
import Bookings from "./scenes/bookings";
import BookingsByStatus from "./scenes/bookings/indexByStatus";
import GuestLists from "./scenes/guestlists";
import GuestListsByRsvpStatus from "./scenes/guestlists/indexByRsvpStatus";
import TicketingAndRegistration from "./scenes/ticketingandregistration";
import TicketingAndRegistrationByTicketType from "./scenes/ticketingandregistration/indexByTicketType";
import TicketingAndRegistrationByRegistrationStatus from "./scenes/ticketingandregistration/indexByRegistrationStatus";
import SeatingArrangements from "./scenes/seatingarrangements";
import Menus from "./scenes/menus";
import MenusByCategory from "./scenes/menus/indexByCategory";
import Catering from "./scenes/catering";
import TaskManagement from "./scenes/taskmanagement";
import TaskManagementByPriority from "./scenes/taskmanagement/indexByPriority";
import TaskManagementByStatus from "./scenes/taskmanagement/indexByStatus";
import Invoices from "./scenes/invoices";
import InvoicesByStatus from "./scenes/invoices/indexByStatus";
import InvoicesByCurrency from "./scenes/invoices/indexByCurrency";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/staff" element={<ProtectedRoute element={<Staff searchTerm={searchTerm} />} />} />
<Route path="/services" element={<ProtectedRoute element={<Services searchTerm={searchTerm} />} />} />
<Route path="/venues" element={<ProtectedRoute element={<Venues searchTerm={searchTerm} />} />} />
<Route path="/vendors" element={<ProtectedRoute element={<Vendors searchTerm={searchTerm} />} />} />
<Route path="/menuitems" element={<ProtectedRoute element={<MenuItems searchTerm={searchTerm} />} />} />
<Route path="/events" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/events/list" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/bookings" element={<ProtectedRoute element={<Bookings searchTerm={searchTerm} />} />} />
<Route path="/bookings/list" element={<ProtectedRoute element={<Bookings searchTerm={searchTerm} />} />} />
<Route path="/bookings/status" element={<ProtectedRoute element={<BookingsByStatus searchTerm={searchTerm} />} />} />
<Route path="/guestlists" element={<ProtectedRoute element={<GuestLists searchTerm={searchTerm} />} />} />
<Route path="/guestlists/list" element={<ProtectedRoute element={<GuestLists searchTerm={searchTerm} />} />} />
<Route path="/guestlists/rsvpstatus" element={<ProtectedRoute element={<GuestListsByRsvpStatus searchTerm={searchTerm} />} />} />
<Route path="/ticketingandregistration" element={<ProtectedRoute element={<TicketingAndRegistration searchTerm={searchTerm} />} />} />
<Route path="/ticketingandregistration/list" element={<ProtectedRoute element={<TicketingAndRegistration searchTerm={searchTerm} />} />} />
<Route path="/ticketingandregistration/tickettype" element={<ProtectedRoute element={<TicketingAndRegistrationByTicketType searchTerm={searchTerm} />} />} />
<Route path="/ticketingandregistration/registrationstatus" element={<ProtectedRoute element={<TicketingAndRegistrationByRegistrationStatus searchTerm={searchTerm} />} />} />
<Route path="/seatingarrangements" element={<ProtectedRoute element={<SeatingArrangements searchTerm={searchTerm} />} />} />
<Route path="/seatingarrangements/list" element={<ProtectedRoute element={<SeatingArrangements searchTerm={searchTerm} />} />} />
<Route path="/menus" element={<ProtectedRoute element={<Menus searchTerm={searchTerm} />} />} />
<Route path="/menus/list" element={<ProtectedRoute element={<Menus searchTerm={searchTerm} />} />} />
<Route path="/menus/category" element={<ProtectedRoute element={<MenusByCategory searchTerm={searchTerm} />} />} />
<Route path="/catering" element={<ProtectedRoute element={<Catering searchTerm={searchTerm} />} />} />
<Route path="/catering/list" element={<ProtectedRoute element={<Catering searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement" element={<ProtectedRoute element={<TaskManagement searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/list" element={<ProtectedRoute element={<TaskManagement searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/priority" element={<ProtectedRoute element={<TaskManagementByPriority searchTerm={searchTerm} />} />} />
<Route path="/taskmanagement/status" element={<ProtectedRoute element={<TaskManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/invoices" element={<ProtectedRoute element={<Invoices searchTerm={searchTerm} />} />} />
<Route path="/invoices/list" element={<ProtectedRoute element={<Invoices searchTerm={searchTerm} />} />} />
<Route path="/invoices/status" element={<ProtectedRoute element={<InvoicesByStatus searchTerm={searchTerm} />} />} />
<Route path="/invoices/currency" element={<ProtectedRoute element={<InvoicesByCurrency searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
